import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { Fragment } from 'react'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ObjectBoxTitleProps {
  className?: string
  title?: React.ReactNode
  proportional?: {
    viewable: number
    total: number
  }
  static?: {
    label: React.ReactNode
    count: number
  }
}

const ObjectBoxTitle: React.FC<ObjectBoxTitleProps> = (
  props,
): React.ReactNode => {
  const translate = useTranslate()

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        align-items: center;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          flex-direction: column;
          align-items: flex-start;
        `)}
      `}
    >
      {props.title !== undefined && (
        <span
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            margin-right: 16px;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
              margin-right: 0px;
            `)}
          `}
        >
          {props.title}
        </span>
      )}
      {props.proportional !== undefined && (
        <Fragment>
          <span
            css={css`
              ${getFontCss(
                20,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.regular,
              )};

              ${getBreakpointDown(breakpointSizes.XSM)(css`
                display: none;
              `)}
            `}
          >
            {translate('Showing ${viewableCount} of ${totalCount}', {
              viewableCount: `${props.proportional.viewable}`,
              totalCount: `${props.proportional.total}`,
            })}
          </span>
          <span
            css={css`
              margin-top: 2px;
              ${getFontCss(
                16,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.medium,
              )};

              ${getBreakpointUp(breakpointSizes.SM)(css`
                display: none;
              `)}
            `}
          >
            {translate('${viewableCount} of ${totalCount}', {
              viewableCount: `${props.proportional.viewable}`,
              totalCount: `${props.proportional.total}`,
            })}
          </span>
        </Fragment>
      )}
      {props.static !== undefined && (
        <span
          css={css`
            ${getFontCss(
              20,
              themeConstants.colors.highlight,
              styleConstants.fontFamilies.regular,
            )};

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                16,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.medium,
              )};
              margin-left: 0px;
            `)}
          `}
        >
          {translate('${count} ${label}', {
            count: `${props.static.count}`,
            label: props.static.label,
          })}
        </span>
      )}
    </div>
  )
}

export default ObjectBoxTitle
